import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2e4a1d49: FaireBrandEntity = {
  token: "b_2e4a1d49",
  type: "brand",
  name: "Carolyn Suzuki",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/07c50c003c01de1bc6823a4a9a2a16cf5fcb4be32ce467c8104bce6a58b9e99b/1560381540.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/49ccea839161a6eceae008729221ae2608b0121a96c05cffddd5e75314dccf63.jpeg",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/07c50c003c01de1bc6823a4a9a2a16cf5fcb4be32ce467c8104bce6a58b9e99b/1560381540.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/49ccea839161a6eceae008729221ae2608b0121a96c05cffddd5e75314dccf63.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 157,
  isTopShop: true,
  isInsider: true,
  description:
    "Carolyn Suzuki Goods is owned and operated by Carolyn. \nAs a proud native of Los Angeles, she hopes that her line inspired by her hometown, rich in culture, nature & fun folks comes through in each product that she designs.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:55.333Z",
    importedBy: "entity-db-cli",
  },
};
